import { MaterialsSubmittalModel } from "./MaterialsSubmittal.model";

export class MaterialsSubmittal extends MaterialsSubmittalModel {
    // Add custom methods here
}
